var render, staticRenderFns
import script from "./TrafficBarChart.vue?vue&type=script&lang=js&"
export * from "./TrafficBarChart.vue?vue&type=script&lang=js&"
import style0 from "./TrafficBarChart.vue?vue&type=style&index=0&id=652c6678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652c6678",
  null
  
)

/* custom blocks */
import block0 from "./TrafficBarChart.vue?vue&type=custom&index=0&blockType=canvas&ref=barChart"
if (typeof block0 === 'function') block0(component)

export default component.exports